import { render, staticRenderFns } from "./patientsList.vue?vue&type=template&id=1b436471&"
import script from "./patientsList.vue?vue&type=script&lang=js&"
export * from "./patientsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports